import axios from "axios";

const backendClient = axios.create({
  baseURL: "https://prod-api.luckify.bet/",
  // baseURL: "https://api.luckify.bet/",
  // baseURL: "http://192.168.30.9:3005/",

  headers: {
    "Content-Type": "application/json",
  },
});

backendClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

backendClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(
        `Response Error [${error.response.status}]:`,
        error.response.data
      );
    } else {
      console.error("Network Error:", error.message);
    }

    // if (error.response?.status === 401) {
    //   window.location.href = '/login';
    // }

    return Promise.reject(error);
  }
);

export default backendClient;
